module.exports = __webpack_public_path__ + "assets/img/rolelabel-f18d5acd.png";